import i18next from 'i18next';

const parseTranslation = (key: string) => {
  let parsedTranslation;

  const translation = i18next.t(key);

  try {
    parsedTranslation = JSON.parse(translation);
  } catch (error) {
    console.error(error);
  }

  return parsedTranslation;
};

export default parseTranslation;
